export function getCompletionRateChange(current: number, previous?: number) {
  if (previous == null || previous === 0) {
    return {
      change: '0%',
      increased: false,
    }
  }

  const difference = current - previous
  const percentageChange = (difference / previous) * 100
  const increased = percentageChange > 0

  const formattedPercentage = (percentageChange / 100).toLocaleString('en-US', {
    style: 'percent',
    minimumFractionDigits: 0,
  })
  const operator = increased ? '+' : undefined
  const formatted = [operator, formattedPercentage].join('')
  return {
    change: formatted,
    increased,
  }
}
